import gql from 'graphql-tag'

export const CREATE_NEWS = gql`
  mutation CreateNews($data: NewsItemCreateInput!, $image: Upload) {
    createNewsItem(data: $data, image: $image) {
      id
      name
    }
  }
`

export const UPDATE_NEWS = gql`
  mutation UpdateNews($id: Int!, $data: NewsItemUpdateInput!, $image: Upload) {
    updateNewsItem(id: $id, data: $data, image: $image) {
      id
      name
    }
  }
`

export const DELETE_NEWS = gql`
  mutation DeleteNews($id: Int!) {
    deleteNewsItem(id: $id) {
      id
    }
  }
`
